// @flow

import {
  INIT_FORM,
  INIT_CHECK_STOCK,
  RECEIVED_CHECK_STOCK,
  OUT_OF_STOCK,
  ALTERNATIVES_OVERLAY_CLOSE,
  FORM_SUBMIT_START,
  FORM_SUBMIT_COMPLETE,
} from './constants';

import type { OrderFormState } from './types';

const initialState = {
  isLoading: false,
  isShowingAlternativesOverlay: false,
  stockResult: null,
  formSubmitted: false,
  outOfStockHistory: [],
};

export default (state: OrderFormState = initialState, action: Object): Object => {
  switch (action.type) {
    case INIT_FORM:
      return initialState;
    case INIT_CHECK_STOCK:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVED_CHECK_STOCK:
      return {
        ...state,
        stockResult: action.payload,
        isLoading: false,
      };
    case OUT_OF_STOCK:
      return {
        ...state,
        isLoading: false,
        isShowingAlternativesOverlay: true,
        outOfStockHistory: [...state.outOfStockHistory, action.payload],
      };
    case ALTERNATIVES_OVERLAY_CLOSE:
      return {
        ...state,
        isShowingAlternativesOverlay: false,
      };
    case FORM_SUBMIT_START:
      return {
        ...state,
        isLoading: true,
      };
    case FORM_SUBMIT_COMPLETE:
      return {
        ...state,
        formSubmitted: true,
        isLoading: false,
      };
    default:
      return state;
  }
};
